import React, { useState } from 'react';
import {
    Box,
    Divider,
    Tab,
    Tabs,
    makeStyles,
} from '@material-ui/core';
import TopNav from '../../components/common/TopNav';
import Container from '../../components/Elements/Container';
import ResumenTab from './ResumenTab';
import ClientesTab from './ClientesTab';
import FacturasTab from './FacturasTab';
import CostosTab from './CostosTab';
import VerificacionTab from './VerificacionTab';

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(3),
        background: `linear-gradient(180deg, ${theme.palette.surface.panel} 0%, ${theme.palette.background.default} 100%)`,
        minHeight: '100vh',
    },
    card: {
        borderRadius: 5,
        border: `1px solid ${theme.palette.border.soft}`,
        boxShadow: theme.palette.shadow.card,
        overflow: 'hidden',
        backgroundColor: theme.palette.common.white,
    },
    tabsBar: {
        padding: '0 16px',
        backgroundColor: theme.palette.surface.panel,
    },
    tabsRoot: {
        minHeight: 48,
    },
    tabRoot: {
        minHeight: 48,
        textTransform: 'none',
        fontWeight: 600,
        fontSize: 13,
        padding: '12px 16px',
        color: theme.palette.text.secondary,
        '&.Mui-selected': {
            color: theme.palette.primary.main,
        },
    },
    tabIndicator: {
        height: 3,
        background: theme.palette.primary.main,
        borderRadius: '3px 3px 0 0',
    },
    tabContent: {
        padding: theme.spacing(3),
    },
}));

const TABS = [
    { label: 'Resumen', component: ResumenTab },
    { label: 'Clientes', component: ClientesTab },
    { label: 'Facturas', component: FacturasTab },
    { label: 'Costos IA', component: CostosTab },
    { label: 'Verificación', component: VerificacionTab },
];

export default function LectorStaffPanel() {
    const classes = useStyles();
    const [tab, setTab] = useState(0);
    const ActiveTab = TABS[tab].component;

    return (
        <>
            <TopNav titulo="Lector Staff" subtitulo="| Monitor" />
            <Container>
                <Box className={classes.root}>
                    <Box className={classes.card}>
                        <Box className={classes.tabsBar}>
                            <Tabs
                                value={tab}
                                onChange={(_, v) => setTab(v)}
                                classes={{ root: classes.tabsRoot, indicator: classes.tabIndicator }}
                                variant="scrollable"
                                scrollButtons="auto"
                            >
                                {TABS.map(t => (
                                    <Tab key={t.label} label={t.label} classes={{ root: classes.tabRoot }} />
                                ))}
                            </Tabs>
                        </Box>
                        <Divider />
                        <Box className={classes.tabContent}>
                            <ActiveTab />
                        </Box>
                    </Box>
                </Box>
            </Container>
        </>
    );
}
